var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_vm._v(" News ")])
}
var staticRenderFns = []

export { render, staticRenderFns }